class NgEditFinishedDirective {
    static $inject = ['$document', '$timeout'];

    constructor($document, $timeout) {
        this.restrict = 'A';
        this.$document = $document;
        this.$timeout = $timeout;
    }

    static factory($document, $timeout) {
        'ngInject';
        return new NgEditFinishedDirective($document, $timeout);
    }
    get scope() {
        return {
            onEditFinished: '&ngEditFinished',
        };
    }

    link(scope, element) {
        element.on('keydown', e => {
            // enter
            if (e.which === 13 && !e.altKey && !e.ctrlKey && !e.metaKey && !e.shiftKey) {
                e.preventDefault();
                scope.$apply(() => scope.onEditFinished({ $event: e, $confirm: true }));
            }
            // escape
            else if (e.which === 27) {
                scope.$apply(() => scope.onEditFinished({ $event: e, $confirm: false }));
            }
        });

        const onClickOutsideHandler = this._onClickOutside.bind(this, scope, element);

        this.$timeout(() => {
            this.$document.on('click', onClickOutsideHandler);
            this.$document.on('touchstart', onClickOutsideHandler);
        });

        scope.$on('$destroy', () => {
            element.off('keydown');
            this.$document.off('click', onClickOutsideHandler);
            this.$document.off('touchstart', onClickOutsideHandler);
        });
    }

    _onClickOutside(scope, element, $event) {
        if ($event.target !== element[0]) {
            scope.$apply(() => scope.onEditFinished({ $event, $confirm: true }));
        }
    }
}

// Explicit DI annotation for factory used in angular.directive registration
NgEditFinishedDirective.factory.$inject = ['$document', '$timeout'];
export default NgEditFinishedDirective.factory;
